import { subCompanyAssignedAeApi } from 'app/services/api';

import { mapAccountExecutive } from 'utils/accountExecutive';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop. The forbidden-skip stops
// the reload; fetchSafe swallows the rejection so it leaves no unhandled-rejection
// console error / dev overlay (DEV-4370).
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_ACCOUNT_EXECUTIVE_ACTION_TYPE = createNamedActions(
  'commandCenterAccountExecutive',
  {
    SET_ACCOUNT_EXECUTIVE: 'SET_ACCOUNT_EXECUTIVE',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterAccountExecutiveAction = catchAsyncActionError(
  () => async dispatch => {
    const data = await fetchSafe(() =>
      subCompanyAssignedAeApi.getAssignedAeCard({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    return dispatch({
      type: COMMAND_CENTER_ACCOUNT_EXECUTIVE_ACTION_TYPE.SET_ACCOUNT_EXECUTIVE,
      payload: mapAccountExecutive(data),
    });
  },
);
